module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- headline_copy %></h3> <div class=\"copy\"><%- sub_headline_copy %></div> <% if(share.display_on_closed === 'true') { %> <div class=\"thanks-social\"> <h3 class=\"share-copy\"><%- share.share_copy %></h3> <% if(share.display_facebook === \"true\") { %> <div class=\"thanks\"> <a href=\"javascript:void(0)\"> <div class=\"facebook\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678194.5674.png\"> <%- share.text %> </div> </a> </div> <% }; %> <% if(share.display_twitter === 'true') { %> <div class=\"thanks\"> <a href=\"<%- twShareUrl %>\" target=\"_blank\" data-url=\"<%- twShareUrl %>\"> <div class=\"twitter\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1420659330.8224.png\"> <%- share.tweet %> </div> </a> </div> <% }; %> <% if(share.display_google === 'true') { %> <div class=\"thanks\"> <a href=\"https://plus.google.com/share?url={<%- google %>}\" onclick=\"window.open(this.href,\n  '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;\"> <div class=\"google\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png\"> </div> </a> </div> <% }; %> </div> <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  headline_copy ), '</h3> <div class="copy">', (__stack.lineno=1,  sub_headline_copy ), '</div> ');__stack.lineno=1; if(share.display_on_closed === 'true') { ; buf.push(' <div class="thanks-social"> <h3 class="share-copy">', (__stack.lineno=1,  share.share_copy ), '</h3> ');__stack.lineno=1; if(share.display_facebook === "true") { ; buf.push(' <div class="thanks"> <a href="javascript:void(0)"> <div class="facebook"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678194.5674.png"> ', (__stack.lineno=1,  share.text ), ' </div> </a> </div> ');__stack.lineno=1; }; ; buf.push(' ');__stack.lineno=1; if(share.display_twitter === 'true') { ; buf.push(' <div class="thanks"> <a href="', (__stack.lineno=1,  twShareUrl ), '" target="_blank" data-url="', (__stack.lineno=1,  twShareUrl ), '"> <div class="twitter"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1420659330.8224.png"> ', (__stack.lineno=1,  share.tweet ), ' </div> </a> </div> ');__stack.lineno=1; }; ; buf.push(' ');__stack.lineno=1; if(share.display_google === 'true') { ; buf.push(' <div class="thanks"> <a href="https://plus.google.com/share?url={', (__stack.lineno=1,  google ), '}" onclick="window.open(this.href,\n  \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600\');return false;"> <div class="google"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png"> </div> </a> </div> ');__stack.lineno=2; }; ; buf.push(' </div> ');__stack.lineno=2; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/templates/window.ejs
// module id = 240
// module chunks = 0